export default "__VITE_ASSET__BEusXLuG__"